var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dotlottie-player',{class:_vm.animationType == 'login' ? '' : 'animation-body',attrs:{"src":_vm.animation[_vm.animationType],"autoplay":"","loop":""}})}
var staticRenderFns = []

export { render, staticRenderFns }